// src/store/orderListSlice.js
import { createSlice } from "@reduxjs/toolkit";
import moment from "moment";

const today = moment().format("YYYY-MM-DD");

const initialState = {
  startDate: today,
  endDate: today,

  // ✅ ADDED (required for UI)
  orders: [],
  isOrderListDataFetched: false,
};

const orderListSlice = createSlice({
  name: "orderList",
  initialState,
  reducers: {
    setOrderList: (state, action) => {
      // ✅ FIX: store API data where UI expects it
      state.orders = action.payload;
    },

    deleteOrder: (state, action) => {
      // ✅ SAFE delete (supports id or _id)
      state.orders = state.orders.filter(
        o => o.id !== action.payload && o._id !== action.payload
      );
    },

        // ✅ ADD THIS
    addOrder: (state, action) => {
      state.orders.push(action.payload);
    },

    setStartDate: (state, action) => {
      state.startDate = action.payload;
    },

    setEndDate: (state, action) => {
      state.endDate = action.payload;
    },

    setOrderListDataFetched: (state, action) => {
      state.isOrderListDataFetched = action.payload;
    },
  },
});

export const {
  deleteOrder,
  setStartDate,
  setEndDate,
  setOrderList,
  setOrderListDataFetched,
  addOrder, // 🔹 ADDED export
} = orderListSlice.actions;

export default orderListSlice.reducer;
